import {useState, useEffect, Fragment, useCallback} from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Stack, TextField, Paper, Avatar, ClickAwayListener} from '@mui/material'
import { DataGrid, GridCellEditStopReasons } from '@mui/x-data-grid';
import CategoryIcon from '@mui/icons-material/Category';
import { Card, CardContent, Typography, Button, ButtonBase, CircularProgress, Alert } from '@mui/material';

const envConfig = {
  url : (process.env.REACT_APP_ENVIROMENT === "prod") ? process.env.REACT_APP_URL_PROD : process.env.REACT_APP_URL_DEV
};

const SearchContent = ({products, setProducts, setValidate}) => {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [SearchContent, setSearchContent] = useState('');
    const [filtered, setFiltered] = useState([]);
    const [valorMercancia, setValorMercancia] = useState(0);

    
    const debounceTimeout = 500;
    let debounceTimer;
    
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${envConfig.url}/api/v2/products/sat_catalog/${SearchContent}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
            'Cache-Control': 'no-cache',
          },
        });
        const data = await response.json();
        setFiltered(data.data.slice(0, 10));
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    const handleSearch = async () => {
      debounceTimer = setTimeout(async () => {
        if (SearchContent === '') {
          setFiltered([]);
        } else {
          await fetchProducts();
        }
      }, debounceTimeout);
    };
    const calculateTotal = (products) => {
      let total = 0;
      products.forEach(product => {
        total += product.productValue * product.quantity;
      });
      return total;
    };
    
    useEffect(() => {
      handleSearch();
    }, [SearchContent]);
    
    useEffect(() => {
      setValidate(true);
    },[]);

    useEffect(() => {
      setValorMercancia(calculateTotal(products));
      console.log('productos', products);
    },[products]);

    return <Stack
            direction='column'
            width={500}
            >
            <Stack sx={{height:60, width:'100%', justifyContent: 'space-around', margin:1}} direction='row'>
              <Avatar sx={{ mt: 1, bgcolor: theme.palette.primary.main}}><CategoryIcon/></Avatar>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                  <Box sx={{ position: 'relative', width: '85%' }}>
                      <TextField
                      variant='outlined'
                      label="Empezar a buscar productos"
                      placeholder='Puedes buscar por codigo de SAT o descripcion'
                      value={SearchContent}
                      onChange={(e)=>setSearchContent(e.target.value)}
                      onFocus={() => setOpen(true)}
                      onKeyDown={e => {
                          if (e.key === 'Tab') setOpen(false);
                          clearTimeout(debounceTimer);
                      }}
                      sx={{ zIndex: 0 }}
                      inputProps={{
                          maxLength: 30
                        }}
                        fullWidth
                        />
                      {open && filtered?.length !== 0 && (
                        <Paper
                          elevation={10}
                          sx={{ p: 2, position: 'absolute', zIndex: 10, maxHeight: 175, width: '100%', overflow: 'auto' }}
                          >
                            <Viewport items={filtered} actualItems={products} setItems={setProducts} closeIt={()=>setOpen(false)}/>
                        </Paper>
                      )}
                  </Box>
              </ClickAwayListener>
            </Stack>
            <ProductsTable rows={products} setItems={setProducts} setValidate={setValidate}/>
        </Stack>
    
}
const Viewport = ({ items, setItems, actualItems, closeIt }) => {
  
    if (items?.length > 0 && items !== undefined) {
      return (
        <Stack spacing={1}>
          {items?.map(item => (
            <Card
              key={item.id.toString()}
              variant='outlined'
              onClick={() => {
                const existingProduct = actualItems.find(product => product.id === item.id);
                if (existingProduct) {
                  alert('El producto ya se ah agregado');
                }
                else{
                    setItems([...actualItems, { ...item, productValue: 0, quantity: 1, description: item.name}]);
                }
                closeIt();
              }}
            >
              <ButtonBase sx={{ width: '100%' }}>
                <CardContent sx={{ width: '100%', textAlign: 'left' }}>
                  <Typography
                      variant='body1'
                      sx={{ fontWeight: 'bold' }}
                    >
                      {`${item.code} - ${item.name} ${item.similar_words!== '' ? `(${item.similar_words})` : ''}`}
                  </Typography>
                </CardContent>
              </ButtonBase>
            </Card>
          ))}
        </Stack>
      )
    }

    return (
      <Stack
        alignItems='center'
        spacing={1}
      >
        <CircularProgress sx={{ fontSize: 40 }} />
        <Typography>Obteniendo listado de productos</Typography>
      </Stack>
    );
  }

const ProductsTable = ({rows, setItems,setValidate}) => {
    const paginationModel = { page: 0, pageSize: 5 };
    const pageSizeOptions = [5, 10, 20];
    
    const handleDelete = (id) => setItems(rows.filter(item => item.id !== id));
    
    const handleProcessRowUpdate = (params) => {
      const updatedRows = rows.map(row => row.id === params.id ? { ...row, [params.field]:params.value } : row);
      setItems(updatedRows);
    };
    
    const Actions = ({item})=>{
      return <Fragment>
                <Button
                  variant='contained'
                  onClick={() => {
                    handleDelete(item.id);
                  }}
                  >
                    Borrar
                </Button>
              </Fragment> 
    }
    
    const columns = [
      { field: 'quantity', headerName: 'Piezas', width: 70, editable: true, type: 'number', headerAlign: 'center', align: 'center' },
      { field: 'code', headerName: 'SAT', width: 100, headerAlign: 'center', align: 'center' },
      // { field: 'name', headerName: 'Nombre', width: 100, hidden:true },
      { field: 'description', headerName: 'Descripcion', width: 150, editable: true, type: 'string', headerAlign: 'center', align: 'center'},
      // { field: 'productValue', headerName: 'Valor c/ iva', width: 100, editable: true, type: 'number', headerAlign: 'center', align: 'center' },
      { field: 'productValue', headerName: 'Valor c/ iva', width: 100, editable: true, type: 'number', headerAlign: 'center', align: 'center'},
      // { field: 'quantity', headerName: 'Piezas', width: 50, editable: true, type: 'number', headerAlign: 'center', align: 'center', 
        // onCellEditCommit: (params) => {
        //   const updatedRows = rows.map(row => row.code === params.id ? { ...row, quantity: params.value } : row);
        //   setItems(updatedRows);
        // }
      // },
      { field: 'actions', headerName: 'Acciones', width: 100, renderCell: (items) => <Actions item={items}/>, headerAlign: 'center', align: 'center' },
    ];

    return <Paper sx={{ height: 400, width: '100%', spacing: 2 }}>
          <Alert severity='info'>
          <Typography>
            Dale doble click para editar los productos
          </Typography>
          </Alert>
          <DataGrid
              rows={rows}
              columns={columns}
              pageSizeOptions={pageSizeOptions}
              sx={{ border: 0 }}
              onCellEditStart={() => {
                setValidate(false);
              }}
              editMode="cell"
              onCellEditStop={() => {
                setValidate(true);
              }}
              onCellEditCommit={handleProcessRowUpdate}
          />
        </Paper>
}
export default function SetPackageContent({ content, setContent, setValidate, merchandiseValue}) {
  const [valorMercancia, setValorMercancia] = useState(0);
  useEffect(() => {
    setValorMercancia(content.reduce((acc, item) => acc + item.productValue * item.quantity, 0));
  },[content,merchandiseValue]);
    return (
      <>
      <SearchContent products={content} setProducts={setContent} setValidate={setValidate}/>
      <Typography><b>Valor total de la mercancia: </b>{valorMercancia}</Typography>
      {parseInt(merchandiseValue, 10) !== parseInt(valorMercancia, 10) && 
      <Alert severity='warning'>
        <Typography>
        El valor total de la mercancia no coincide con lo declarado en las caracteristicas del paquete
        </Typography>
      </Alert>}
      </>
    );
}